import { FrontTicketPurchaseOfferResponseDto } from '@/lib/jp-api/requests';

export function getOfferTicketPrice(baseOffer: FrontTicketPurchaseOfferResponseDto, offer: FrontTicketPurchaseOfferResponseDto) {
  if (offer.pricingModel === 'fixed') {
    return Number(offer.price) / offer.minimumAmount;
  } else {
    return (Number(baseOffer.price) / baseOffer.minimumAmount) * (1 - Number(offer.discountPercentage) / 100);
  }
}

export function resolveActiveOfferFromTicketCount(
  baseOffer: FrontTicketPurchaseOfferResponseDto,
  offers: FrontTicketPurchaseOfferResponseDto[],
  ticketCount: number,
) {
  let activeOffer = baseOffer;
  let activePrice = Number(baseOffer.price) / baseOffer.minimumAmount;
  offers.forEach((offer) => {
    if (offer.pricingModel === 'fixed' && offer.minimumAmount === ticketCount) {
      const offerPrice = getOfferTicketPrice(baseOffer, offer);
      if (activePrice > offerPrice) {
        activePrice = offerPrice;
        activeOffer = offer;
      }
    } else if (offer.pricingModel === 'percentage') {
      if (offer.minimumAmount <= ticketCount) {
        const offerPrice = getOfferTicketPrice(baseOffer, offer);
        if (offerPrice < activePrice) {
          activePrice = offerPrice;
          activeOffer = offer;
        }
      }
    }
  });

  return {
    offer: activeOffer,
    price: activePrice,
  };
}
